(function () {
  var inFlight = false;

  function fillUpsell() {
    var slot = document.getElementById('CloveUpsell');
    if (!slot || slot.dataset.filled === '1' || inFlight) return;
    var pid = slot.getAttribute('data-product-id');
    if (!pid) return;
    inFlight = true;
    fetch('/recommendations/products?section_id=clove-cart-upsell&product_id=' + pid + '&limit=4&intent=related')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('.clove-upsell__inner');
        var cur = document.getElementById('CloveUpsell');
        if (cur && inner) {
          cur.innerHTML = inner.innerHTML;
          cur.querySelectorAll('.clove-upsell__select').forEach(cloveUpsellSyncImage);
          cur.dataset.filled = '1';
        }
        inFlight = false;
      })
      .catch(function () { inFlight = false; });
  }

  function refreshDrawer() {
    var path = window.location.pathname + '?section_id=cart-drawer';
    fetch(path)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.drawer__inner');
        var cur = document.querySelector('cart-drawer .drawer__inner');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        return fetch('/cart.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        fillUpsell();
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('.clove-upsell__arrow');
    if (arrow) {
      var wrap = arrow.closest('.clove-upsell__wrap');
      var track = wrap && wrap.querySelector('.clove-upsell__track');
      if (!track) return;
      var slides = track.children.length;
      var idx = parseInt(track.dataset.idx || '0', 10) + parseInt(arrow.dataset.dir, 10);
      idx = Math.max(0, Math.min(idx, slides - 1));
      track.dataset.idx = idx;
      track.style.transform = 'translateX(-' + idx * 100 + '%)';
      return;
    }
    var add = e.target.closest('.clove-upsell__add');
    if (add) {
      var slide = add.closest('.clove-upsell__slide');
      var sel = slide && slide.querySelector('.clove-upsell__select');
      if (!sel || !sel.value) return;
      add.disabled = true;
      add.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(sel.value, 10), quantity: 1 }] })
      })
        .then(function () { refreshDrawer(); })
        .catch(function () { add.disabled = false; add.textContent = 'Add'; });
    }
  });

  function reserveTick() {
    var els = document.querySelectorAll('[data-clove-timer]');
    if (!els.length) return;
    var until = parseInt(sessionStorage.getItem('cloveReserveUntil') || '0', 10);
    var now = Date.now();
    if (!until || until <= now) {
      until = now + 15 * 60 * 1000;
      try { sessionStorage.setItem('cloveReserveUntil', String(until)); } catch (err) {}
    }
    var s = Math.max(0, Math.floor((until - now) / 1000));
    var txt = String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
    els.forEach(function (el) { el.textContent = txt; });
  }
  setInterval(reserveTick, 1000);

  document.addEventListener('DOMContentLoaded', fillUpsell);
  document.addEventListener('DOMContentLoaded', reserveTick);
  function cloveUpsellSyncImage(sel) {
    var slide = sel.closest('.clove-upsell__slide');
    if (!slide) return;
    var img = slide.querySelector('.clove-upsell__media img');
    if (!img) return;
    if (!img.dataset.cloveDefault) img.dataset.cloveDefault = img.getAttribute('src');
    var opt = sel.options[sel.selectedIndex];
    var src = opt ? opt.getAttribute('data-image') : null;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.setAttribute('src', src || img.dataset.cloveDefault);
  }
  document.addEventListener('change', function (e) {
    if (e.target.classList && e.target.classList.contains('clove-upsell__select')) cloveUpsellSyncImage(e.target);
  });
  /* Shipping Protection is ON by default: auto-add it when the cart has
     real items and it is not already there. If the shopper deselects it,
     remember the opt-out for this session and do not re-add. */
  var cloveProtBusy = false;
  function cloveMaybeAutoProtect() {
    try { if (sessionStorage.getItem('cloveProtectionOff') === '1') return; } catch (err) {}
    if (cloveProtBusy) return;
    var toggle = document.getElementById('CloveProtectionToggle');
    if (!toggle || toggle.checked) return;
    cloveProtBusy = true;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hasReal = cart.items.some(function (i) { return i.handle !== 'shipping-protection-1'; });
        var hasProt = cart.items.some(function (i) { return i.handle === 'shipping-protection-1'; });
        if (!hasReal || hasProt) { cloveProtBusy = false; return null; }
        return fetch('/products/shipping-protection-1.js')
          .then(function (r) { if (!r.ok) throw new Error('no protection product'); return r.json(); })
          .then(function (p) {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: p.variants[0].id, quantity: 1 }] })
            });
          })
          .then(function () { cloveProtBusy = false; refreshDrawer(); })
          .catch(function () { cloveProtBusy = false; });
      })
      .catch(function () { cloveProtBusy = false; });
  }
  document.addEventListener('change', function (e) {
    if (!e.target || e.target.id !== 'CloveProtectionToggle') return;
    try {
      if (e.target.checked) sessionStorage.removeItem('cloveProtectionOff');
      else sessionStorage.setItem('cloveProtectionOff', '1');
    } catch (err) {}
    var key = e.target.getAttribute('data-key');
    if (e.target.checked) {
      /* Shipping Protection variant is resolved by product handle, so the
         theme works on any store that has a "shipping-protection-1" product. */
      fetch('/products/shipping-protection-1.js')
        .then(function (r) { if (!r.ok) throw new Error('no protection product'); return r.json(); })
        .then(function (p) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: p.variants[0].id, quantity: 1 }] })
          });
        })
        .then(function () { refreshDrawer(); })
        .catch(function () { refreshDrawer(); });
    } else if (key) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function () { refreshDrawer(); }).catch(function () { refreshDrawer(); });
    }
  });
  var cloveDrawerEl = document.querySelector('cart-drawer');
  if (cloveDrawerEl) {
    new MutationObserver(function () { setTimeout(fillUpsell, 60); setTimeout(cloveMaybeAutoProtect, 350); }).observe(cloveDrawerEl, { childList: true, subtree: true });
  }
  setTimeout(cloveMaybeAutoProtect, 800);
})();

/* Keep the Add to Cart button price in sync with variant AND quantity */
(function () {
  function cloveParseAmount(text) {
    var t = text.replace(/[^0-9.,]/g, '');
    if (!t) return null;
    var lastDot = t.lastIndexOf('.'), lastComma = t.lastIndexOf(',');
    if (lastDot > -1 && lastComma > -1) {
      if (lastDot > lastComma) return parseFloat(t.replace(/,/g, ''));
      return parseFloat(t.replace(/\./g, '').replace(',', '.'));
    }
    if (lastComma > -1) {
      var parts = t.split(',');
      if (parts[parts.length - 1].length === 2) return parseFloat(t.replace(',', '.'));
      return parseFloat(t.replace(/,/g, ''));
    }
    return parseFloat(t);
  }
  function cloveFormatLike(template, value) {
    var m = template.match(/[0-9][0-9.,\s]*[0-9]|[0-9]/);
    if (!m) return template;
    var token = m[0];
    var hasDecimals = /[.,][0-9]{2}$/.test(token);
    var decComma = hasDecimals && token.lastIndexOf(',') > token.lastIndexOf('.');
    var fixed = value.toFixed(hasDecimals ? 2 : 0);
    var intPart = fixed, fracPart = '';
    if (hasDecimals) { var sp = fixed.split('.'); intPart = sp[0]; fracPart = sp[1]; }
    var groupSep = null;
    if (token.indexOf(',') > -1 && !decComma) groupSep = ',';
    if (token.indexOf('.') > -1 && decComma) groupSep = '.';
    if (groupSep) intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, groupSep);
    var out = hasDecimals ? intPart + (decComma ? ',' : '.') + fracPart : intPart;
    return template.replace(token, out);
  }
  function cloveSyncAtcPrice() {
    document.querySelectorAll('product-info').forEach(function (info) {
      var tag = info.querySelector('.clove-atc-price');
      if (!tag) return;
      var priceEl = info.querySelector('.price .price-item--sale, .price .price-item--regular');
      if (!priceEl) return;
      var unitText = priceEl.textContent.trim();
      var display = unitText;
      var qtyInput = info.querySelector('.quantity__input');
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      if (qty > 1) {
        var unit = cloveParseAmount(unitText);
        if (unit != null) display = cloveFormatLike(unitText, unit * qty);
      }
      var next = ' \u2022 ' + display;
      if (tag.textContent !== next) tag.textContent = next;
    });
  }
  function cloveInitAtcPrice() {
    cloveSyncAtcPrice();
    document.querySelectorAll('product-info').forEach(function (info) {
      var target = info.querySelector('[id^="price-"]') || info;
      new MutationObserver(cloveSyncAtcPrice).observe(target, { childList: true, subtree: true, characterData: true });
    });
    document.addEventListener('change', function (e) {
      if (e.target.classList && e.target.classList.contains('quantity__input')) setTimeout(cloveSyncAtcPrice, 30);
    });
    document.addEventListener('input', function (e) {
      if (e.target.classList && e.target.classList.contains('quantity__input')) setTimeout(cloveSyncAtcPrice, 30);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cloveInitAtcPrice);
  else cloveInitAtcPrice();
})();

/* Rating line click -> smooth-scroll to the reviews section */
document.addEventListener('click', function (e) {
  var link = e.target.closest('[data-scroll-to-reviews]');
  if (!link) return;
  var target = document.querySelector('.clove-reviews');
  if (!target) return;
  e.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
});
